import * as React from 'react';
import { accentUtils } from '../../services/HelperService';
import { AccentCheckUnbound } from '../unbound/AccentCheckUnbound';
import { ConfiguratorContext } from './ConfigContextProvider';

import { isReadOnly, onSimpleOptionValueChanged, useValidation, getOptionModel, useRefreshKey, optionAccessibleName } from './ProductConfiguratorShared';

export const ConfigCheckbox = props => {

    const ctx = React.useContext(ConfiguratorContext)
    const optionModel = getOptionModel(ctx, props.optionID);

    

    const validation = useValidation(props.optionID, "ConfigNumeric");

    const [value, setValue] = React.useState(accentUtils.isEmpty(optionModel.CurrentValueAsString) ? null : optionModel.CurrentValueAsString?.toString()?.toUpperCase() === "TRUE");

    const refreshKey = useRefreshKey(props.optionID, value);

    const fireChange = React.useMemo(() => onSimpleOptionValueChanged(), [props.optionID]);


    const onChange = React.useCallback(e => {

        fireChange(ctx, optionModel, e.checked?.toString());

        setValue(e.checked);

    }, [setValue, ctx, optionModel, fireChange]);


    const readOnly = isReadOnly(optionModel);


    return <div className="config-control config-checkbox">
        <AccentCheckUnbound
            key={refreshKey.refreshID}
            required={validation.required}
            defaultValue={accentUtils.isEmpty(optionModel.CurrentValueAsString) ? null : optionModel.CurrentValueAsString?.toString()?.toUpperCase() === "TRUE"}
            onChange={onChange}
            disabled={readOnly}
            ariaLabel={optionAccessibleName(optionModel)}
        />
    </div>;
};

